import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import { MASTER_USER_SAVE_ENDPOINT, GET_USER_DATA_UPDATE } from '../../../utils/api';
import MasterNavbar from '../../../components/layout/MasterNavbar';
import { useNavigate, useParams } from 'react-router-dom';

function UsersAdd() {
  const [form, setForm] = useState({
    name: '',
    mobile: '',
    email: '',
    password: ''
  });

  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();
  const { id, master_user_token } = useParams(); // get from URL

  useEffect(() => {
    if (id && master_user_token) {
      setEditMode(true);
      axios.post(GET_USER_DATA_UPDATE, { id, master_user_token })
        .then(res => {
          if (res.data.success && res.data.user) {
            setForm({
              name: res.data.user.name || '',
              mobile: res.data.user.mobile || '',
              email: res.data.user.email || '',
              password: '' // blank for security, allow to reset
            });
          } else {
            toast.error(res.data.message || 'Failed to load user');
          }
        })
        .catch(() => toast.error('Error loading user data'));
    }
  }, [id, master_user_token]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const payload = { ...form };
    if (editMode) {
      payload.id = id;
      payload.master_user_token = master_user_token;
    }

    try {
      const res = await axios.post(MASTER_USER_SAVE_ENDPOINT, payload);
      if (res.data.success) {
        toast.success(res.data.message || 'User saved successfully');
        setTimeout(() => navigate('/users/show'), 1200);
      } else {
        toast.error(res.data.message || 'Failed to save user');
      }
    } catch {
      toast.error('Server error while saving user');
    }
  };

  return (
    <>
      <MasterNavbar />
      <Toaster position="top-center" />
      <div className="container mt-5">
        <div className="card shadow p-4 mx-auto" style={{ maxWidth: '600px' }}>
          <h4 className="mb-4 text-center">
            {editMode ? '✏️ Edit Master User' : '➕ Add Master User'}
          </h4>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Name"
            name="name"
            value={form.name}
            onChange={handleChange}
          />
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Mobile"
            name="mobile"
            value={form.mobile}
            onChange={handleChange}
          />
          <input
            type="email"
            className="form-control mb-3"
            placeholder="Email"
            name="email"
            value={form.email}
            onChange={handleChange}
          />
          <input
            type="password"
            className="form-control mb-4"
            placeholder="Password"
            name="password"
            value={form.password}
            onChange={handleChange}
          />

          <button className="btn btn-primary w-100" onClick={handleSubmit}>
            {editMode ? 'Update User' : 'Save User'}
          </button>
        </div>
      </div>
    </>
  );
}

export default UsersAdd;
